@if (service.visible$ | async) {
  <mat-progress-bar [@fadeInOut] color="accent" mode="indeterminate"></mat-progress-bar>
}
